import { LocalizationService } from '@abp/ng.core';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AgentSummaryDto } from 'src/core/models/feedback/agent-summary.dto';
import { FeedbackService } from 'src/core/services/feedback/feedback.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService } from '@abp/ng.theme.shared';
import { FeedbackDto } from 'src/core/models/feedback/feedback.dto';
import { FeedbackStatus } from 'src/core/models/generic-lookup-type/feedback/feedback-status.glt';
import { finalize, take } from 'rxjs';
import { FormatHelper } from 'src/core/helpers/format.helper';

@Component({
  selector: 'ca-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  standalone: false,
})
export class FeedbackComponent implements OnInit {
  @Input() agentId!: string;
  @Input() sourceId!: number;
  feedbackMessage: string = '';
  agentSummary: AgentSummaryDto | null = null;
  selectedPeriod: number = 7;
  isLoading: boolean = false;

  constructor(
    private feedbackService: FeedbackService,
    private localizationService: LocalizationService,
    private modalService: NgbModal,
    private toastr: ToasterService,
    public formatHelper: FormatHelper
  ) {}

  ngOnInit(): void {
    if (this.agentId) {
      this.loadAgentSummary();
    }
  }

  loadAgentSummary(): void {
    this.isLoading = true;
    const { from, to } = this.getDateRange(this.selectedPeriod);

    this.feedbackService
      .getAgentSummary(this.agentId, from, to)
      .pipe(
        take(1),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: res => (this.agentSummary = res),
        error: () => {
          this.toastr.error(this.localizationService.instant('::Feedback:FailedMessage'));
          this.closeModal();
        },
      });
  }

  changePeriod(days: number): void {
    this.selectedPeriod = days;
    this.loadAgentSummary();
  }

  closeModal(): void {
    this.modalService.dismissAll();
  }

  saveFeedback(): void {
    if (!this.isFeedbackValid()) return;

    this.isLoading = true;
    const feedbackData: FeedbackDto = {
      agentId: this.agentId,
      sourceId: this.sourceId,
      feedback: this.feedbackMessage,
      statusId: FeedbackStatus.unread,
    };
    this.feedbackService
      .create(feedbackData)
      .pipe(
        take(1),
        finalize(() => (this.isLoading = false))
      )
      .subscribe({
        next: () => {
          this.toastr.success(this.localizationService.instant('::Feedback:Submitted'));
          this.closeModal();
        },
        error: () => {
          this.toastr.warn(this.localizationService.instant('::Feedback:SaveFailedMessage'));
        },
      });
  }

  private getDateRange(days: number): { from: Date; to: Date } {
    const to = new Date();
    to.setHours(23, 59, 59, 999);

    const from = new Date();
    from.setDate(to.getDate() - days + 1);
    from.setHours(0, 0, 0, 0);

    return { from, to };
  }

  isFeedbackValid(): boolean {
    if (this.feedbackMessage.trim().length < 5) {
      this.toastr.warn(this.localizationService.instant('::Feedback:Must5Digit'));
      return false;
    }
    return true;
  }
}
